import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
const CUSTOMERS = ['Sarah de Miami', 'Elena de Madrid', 'Carla de Buenos Aires', 'Ana de Santiago', 'Valentina de Bogotá', 'Lucía de Lima', 'Marta de Barcelona', 'Sofía de Ciudad de México', 'Isabella de Montevideo', 'Camila de Asunción'];
const PRODUCTS = ['Lo Estás Haciendo Bien', 'Guía Emocional', 'Pack Reconexión'];
export function SalesNotification() {
  const [isVisible, setIsVisible] = useState(false);
  const [customer, setCustomer] = useState('');
  const [product, setProduct] = useState('');
  const [isDismissed, setIsDismissed] = useState(false);
  useEffect(() => {
    // Initial delay before starting the loop
    const startTimeout = setTimeout(() => {
      triggerNotification();
    }, 5000);
    const triggerNotification = () => {
      if (isDismissed) return;
      // Randomize content
      setCustomer(CUSTOMERS[Math.floor(Math.random() * CUSTOMERS.length)]);
      setProduct(PRODUCTS[Math.floor(Math.random() * PRODUCTS.length)]);
      setIsVisible(true);
      // Haptic feedback if available
      if (typeof navigator !== 'undefined' && navigator.vibrate) {
        navigator.vibrate(200);
      }
      // Hide after 3 seconds
      setTimeout(() => {
        setIsVisible(false);
        // Schedule next appearance after 20 seconds
        setTimeout(triggerNotification, 20000);
      }, 4000); // Slightly longer than 3s to allow reading
    };
    return () => clearTimeout(startTimeout);
  }, [isDismissed]);
  if (isDismissed) return null;
  return <div className="fixed bottom-6 left-0 right-0 z-50 flex justify-center px-4 md:hidden pointer-events-none" data-id="element-357">
      <AnimatePresence data-id="element-358">
        {isVisible && <motion.div initial={{
        opacity: 0,
        y: 50,
        scale: 0.9
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.95
      }} transition={{
        type: 'spring',
        stiffness: 300,
        damping: 25
      }} className="pointer-events-auto relative w-full max-w-sm bg-[#1c1c1e]/90 backdrop-blur-md text-white p-3 rounded-2xl shadow-2xl border border-white/10 flex items-center gap-3" data-id="element-359">
            {/* Product Image */}
            <div className="flex-shrink-0" data-id="element-360">
              <img src="https://cdn.magicpatterns.com/uploads/75ahWB6tEt8eWH9m8UFXP2/LO_ESTAS_HACIENDO_BIEN_1X1_IMAGEN.png" alt="Product" className="w-12 h-12 rounded-lg object-cover border border-white/10" data-id="element-361" />
            </div>

            {/* Content */}
            <div className="flex-1 min-w-0" data-id="element-362">
              <div className="flex items-center gap-1.5 mb-0.5" data-id="element-363">
                <div className="w-1.5 h-1.5 rounded-full bg-green-500 animate-pulse" data-id="element-364" />
                <p className="text-[10px] font-medium text-gray-400 uppercase tracking-wide" data-id="element-365">
                  Compra reciente
                </p>
              </div>
              <p className="text-xs font-medium text-gray-200 truncate" data-id="element-366">
                {customer}
              </p>
              <p className="text-xs text-gray-400 truncate" data-id="element-367">
                compró{' '}
                <span className="text-white font-semibold" data-id="element-368">{product}</span>
              </p>
            </div>

            {/* Close Button */}
            <button onClick={e => {
          e.stopPropagation();
          setIsVisible(false);
          setIsDismissed(true);
        }} className="absolute top-2 right-2 p-1 text-gray-400 hover:text-white transition-colors" data-id="element-369">
              <X size={14} data-id="element-370" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}